// Sets GPT's page-level page_url to the current URL without the query string. It is
// page-level, so it also reaches the slots Freestar defines for its own placements.
export default function applyPageUrl(pubads) {
  if (!pubads || typeof pubads.set !== 'function' || typeof window === 'undefined' || !window.location) return;
  pubads.set('page_url', window.location.origin + window.location.pathname);
}
